import { render } from "./Button.vue?vue&type=template&id=ca981c94"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=ca981c94&lang=scss"

import exportComponent from "/var/www/vimashenets/data/www/valera.report.tz365.ru/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__